import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HvSvg from 'src/components/HvSvg';
import uiDux from 'src/redux/ui';

import {
  ButtonGroup,
  CloseModalIcon,
  Description,
  IconContainer,
  Modal,
  ModalContent,
  ContinueButton,
  Title,
} from './styled';

export const mapStateToProps = ({ designPro }) => ({
  isEditOriginalModalOpen: designPro.ui.isEditOriginalModalOpen,
});

export const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleEditOriginalCloseClick: uiDux.actions.handleEditOriginalCloseClick,
      handleEditOriginalConfirmClick:
        uiDux.actions.handleEditOriginalConfirmClick,
    },
    dispatch,
  );

export class EditOriginalConfirmationModal extends PureComponent {
  static propTypes = {
    handleEditOriginalCloseClick: PropTypes.func.isRequired,
    handleEditOriginalConfirmClick: PropTypes.func.isRequired,
    isEditOriginalModalOpen: PropTypes.bool.isRequired,
  };

  render() {
    const {
      isEditOriginalModalOpen,
      handleEditOriginalCloseClick,
      handleEditOriginalConfirmClick,
    } = this.props;

    if (!isEditOriginalModalOpen) return null;

    return (
      <Modal isOpen>
        <CloseModalIcon
          size="12"
          role="button"
          onClick={handleEditOriginalCloseClick}
        >
          <HvSvg disabled={false} src={require('src/assets/icons/x.svg')} />
        </CloseModalIcon>

        <ModalContent>
          <IconContainer size="26">
            <HvSvg
              disabled={false}
              src={require('src/assets/icons/design-tool.svg')}
            />
          </IconContainer>

          <Title>Edit Design</Title>

          <Description>
            Note that you can only save one design at the moment. If you want to
            save a new design, you will have to override your previously saved
            design.
          </Description>

          <ButtonGroup>
            <ContinueButton onClick={handleEditOriginalConfirmClick}>
              Ok, Got it
            </ContinueButton>
          </ButtonGroup>
        </ModalContent>
      </Modal>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditOriginalConfirmationModal);
